import * as React from 'react';
import {FunctionComponent} from 'react';
import {Crew, CrewMember} from '../../../../Models/Crew';
import {classNames} from '../../../Support/classNames';
import {Link} from 'react-router-dom';

interface OwnProps {
    crew: Crew;
    members: CrewMember[];
    className?: string;
}

export const CrewMembers: FunctionComponent<OwnProps> = ({crew, members, className}) => {
    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>Your crew</h5>
            </div>
            <div className="card-body">
                <table className="table">
                    <tbody>
                        {members.map((member) => {
                            return (
                                <tr>
                                    <td key={member.crewMembershipId}>
                                        {member.firstName} {member.lastName}{' '}
                                        {member.isCoach ? (
                                            <span className="d-inline-block ms-2 badge rounded-pill bg-secondary">
                                                Coach
                                            </span>
                                        ) : (
                                            ''
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div className="d-flex flex-row justify-content-end">
                    <Link className="btn btn-outline-secondary" to={'/crews/' + crew.id + '/members'}>
                        Manage
                    </Link>
                </div>
            </div>
        </div>
    );
};
